import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SearchSchema } from './-schema';

export const Route = createFileRoute(
  '/_staff/places/_layout/settings/place-sub-codes/',
)({
  validateSearch: zodValidator(SearchSchema),
});
